module.exports = __webpack_public_path__ + "static/media/coliseu_box_6.f9658b37.jpg";